import { render, staticRenderFns } from "./AegisSurface.vue?vue&type=template&id=4dc9a597&"
import script from "./AegisSurface.vue?vue&type=script&lang=js&"
export * from "./AegisSurface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports